/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SetAutoShipmentCheckoutMemberEnabledApiRequest {
    enabled: boolean;
}

export interface ResponseError {
    errorCode?: string | null;
    fieldName?: string | null;
    message?: string | null;
}

export interface ResponseStatus {
    errorCode?: string | null;
    message?: string | null;
    stackTrace?: string | null;
    errors?: ResponseError[] | null;
}

export interface SetAutoShipmentCheckoutMemberEnabledApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface BlockMemberApiRequest {
    aliasToBlock?: string | null;
}

export interface BlockMemberApiResponse {
    /** @format int32 */
    blockedMemberId: number;
    responseStatus?: ResponseStatus | null;
}

export type GetBlockedMembersApiRequest = object;

export interface BlockedMemberDto {
    /** @format int32 */
    memberId: number;
    alias?: string | null;
    /** @format date-time */
    createdDate: string;
}

export interface GetBlockedMembersApiResponse {
    blockedMembers?: BlockedMemberDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface UnblockMemberApiRequest {
    /** @format int32 */
    memberIdToUnblock: number;
}

export interface UnblockMemberApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetBlueshiftEventApiCredentialsApiRequest = object;

export interface GetBlueshiftEventApiCredentialsApiResponse {
    verificationKey?: string | null;
    eventSignature?: string | null;
    eventApiKey?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface SetBuyerTransactionVisibilityApiRequest {
    transactionIdList?: number[] | null;
    hidden: boolean;
}

export interface SetBuyerTransactionVisibilityApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetCombinedShippingMemberDaysApiRequest {
    /** @format int32 */
    days: number;
}

export interface SetCombinedShippingMemberDaysApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetCombinedShippingMemberEnabledApiRequest {
    enabled: boolean;
}

export interface SetCombinedShippingMemberEnabledApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetCommitOnPaymentMemberEnabledApiRequest {
    enabled: boolean;
}

export interface SetCommitOnPaymentMemberEnabledApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ContactSellerApiRequest {
    /** @format int32 */
    itemId: number;
    message?: string | null;
    sendCopytoSender: boolean;
}

export interface ContactSellerApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ContactHighestBidderApiRequest {
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    receiverMemberId: number;
    message?: string | null;
    sendCopytoSender: boolean;
}

export interface NewBidderDto {
    /** @format int32 */
    memberId: number;
    memberAlias?: string | null;
}

export interface ContactHighestBidderApiResponse {
    responseStatus?: ResponseStatus | null;
    success: boolean;
    message?: string | null;
    newBidder?: NewBidderDto | null;
}

export type DeactivateMemberAccountPermanentlyApiRequest = object;

export interface DeactivateMemberAccountPermanentlyApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetAccountDeactivationSettingsApiRequest = object;

export interface GetAccountDeactivationSettingsApiResponse {
    isAccountDeactivationAllowed: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface DeactivateMemberAccountTemporarilyApiRequest {
    comment?: string | null;
}

export interface DeactivateMemberAccountTemporarilyApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type MemberContactDetailsApiRequest = object;

export interface MemberContactDetailsApiResponse {
    /** @format int32 */
    memberId: number;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
    country?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    alias?: string | null;
    ssn?: string | null;
    countryCodeIso2?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberContactDetailsApiRequest {
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
    country?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    alias?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    userIpAddress?: string | null;
}

export interface CreditSafeLookupResult {
    socialSecurityNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    givenName?: string | null;
}

export enum CreditSafeNameVerificationStatus {
    Valid = 'Valid',
    Invalid = 'Invalid',
    SSNFail = 'SSNFail',
    NotFound = 'NotFound',
    Error = 'Error'
}

export interface CreditSafeNameVerificationResult {
    lookupResult?: CreditSafeLookupResult | null;
    status: CreditSafeNameVerificationStatus;
}

export interface UpdateMemberContactDetailsApiResponse {
    responseStatus?: ResponseStatus | null;
    creditSafeVerificationResult?: CreditSafeNameVerificationResult | null;
}

export enum DisputeStatus {
    New = 'New',
    WaitingForSeller = 'WaitingForSeller',
    TraderaIsInvestigating = 'TraderaIsInvestigating',
    ToBeClosed = 'ToBeClosed',
    WaitingForBuyer = 'WaitingForBuyer',
    BuyerWonDispute = 'BuyerWonDispute',
    SellerWonDispute = 'SellerWonDispute',
    WaitingForReturn = 'WaitingForReturn',
    Appealed = 'Appealed',
    AvslutadUnder120Kr = 'AvslutadUnder120Kr',
    NotEscalated = 'NotEscalated',
    BuyerMarkedAsSolved = 'BuyerMarkedAsSolved'
}

export enum MessageSentBy {
    CsAgent = 'CsAgent',
    Buyer = 'Buyer',
    Seller = 'Seller'
}

export interface DisputeMessageDto {
    /** @format uuid */
    id: string;
    text?: string | null;
    /** @format date-time */
    created: string;
    sentBy: MessageSentBy;
    attachments?: string[] | null;
}

export interface DisputeApiDto {
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    buyerMemberId: number;
    /** @format int32 */
    sellerMemberId: number;
    message?: string | null;
    status: DisputeStatus;
    /** @format date-time */
    timeStamp: string;
    messages?: DisputeMessageDto[] | null;
}

export interface GetDisputeApiResponse {
    dispute?: DisputeApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDisputeApiRequest {
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    reason: number;
    message?: string | null;
}

export interface CreateDisputeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface AddDisputeMessageApiRequest {
    /** @format int32 */
    transactionId: number;
    message?: string | null;
    attachments?: string[] | null;
}

export interface AddDisputeMessageApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ChangeDisputeStatusToAppealedApiRequest {
    /** @format int32 */
    transactionId: number;
}

export interface ChangeDisputeStatusToAppealedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface MarkDisputeAsEscalatedApiRequest {
    /** @format int32 */
    transactionId: number;
}

export interface MarkDisputeAsEscalatedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface MarkDisputeAsSolvedApiRequest {
    /** @format int32 */
    transactionId: number;
}

export interface MarkDisputeAsSolvedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface GetDisputesApiResponse {
    disputes?: DisputeApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export type MemberEmailSettingsApiRequest = object;

export interface MemberEmailSettingsApiResponse {
    /** @format int32 */
    memberId: number;
    notifyWhenItemBecomesUnsold: boolean;
    notifyOnFirstWinningBid: boolean;
    notifyBeforeWishListItemEnds: boolean;
    acceptsNewsLetter: boolean;
    acceptsOfferEmails: boolean;
    acceptsUpiInfoEmails: boolean;
    acceptsUnknownDeviceOrIpEmails: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberEmailSettingsApiRequest {
    notifyWhenItemBecomesUnsold: boolean;
    notifyOnFirstWinningBid: boolean;
    notifyBeforeWishListItemEnds: boolean;
    acceptsNewsLetter: boolean;
    acceptsOfferEmails: boolean;
    acceptsUpiInfoEmails: boolean;
    acceptsUnknownDeviceOrIpEmails?: boolean | null;
}

export interface UpdateMemberEmailSettingsApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum FeedbackRoleFilter {
    All = 'All',
    Seller = 'Seller',
    Buyer = 'Buyer',
    LeftBy = 'LeftBy'
}

export enum FeedbackRatingFilter {
    All = 'All',
    Positive = 'Positive',
    Negative = 'Negative'
}

export interface FeedbackSummaryItemApiDto {
    /** @format int32 */
    totalNegative: number;
    /** @format int32 */
    totalPositive: number;
}

export interface TotalFeedbackSummaryForMemberApiDto {
    /** @format int32 */
    memberId: number;
    lastMonth?: FeedbackSummaryItemApiDto | null;
    lastSixMonths?: FeedbackSummaryItemApiDto | null;
    lastTwelveMonths?: FeedbackSummaryItemApiDto | null;
    sinceRegistration?: FeedbackSummaryItemApiDto | null;
    unique?: FeedbackSummaryItemApiDto | null;
}

export interface DetailedSellerRatingApiDto {
    category?: string | null;
    /** @format int32 */
    categoryCount: number;
    /** @format double */
    averageRating: number;
}

export interface DetailedSellerRatingSummaryForMemberApiDto {
    /** @format int32 */
    memberId: number;
    itemDescription?: DetailedSellerRatingApiDto | null;
    communication?: DetailedSellerRatingApiDto | null;
    deliveryTime?: DetailedSellerRatingApiDto | null;
    shippingCost?: DetailedSellerRatingApiDto | null;
    /** @format double */
    detailedSellerRatingAverage: number;
}

export enum MemberAccountState {
    None = 'None',
    Active = 'Active',
    TemporarySuspended = 'TemporarySuspended',
    PermanentlySuspended = 'PermanentlySuspended',
    Deregistered = 'Deregistered'
}

export enum FeedbackRoleApiDto {
    Buyer = 'Buyer',
    Seller = 'Seller'
}

export enum FeedbackRatingApiDto {
    None = 'None',
    Negative = 'Negative',
    Positive = 'Positive'
}

export enum MutualFeedbackRemovalStatus {
    Available = 'Available',
    Unavailable = 'Unavailable',
    Requested = 'Requested',
    Received = 'Received',
    Denied = 'Denied'
}

export interface MutualFeedbackRemovalItemApiDto {
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    feedbackRemovalRequestId?: number | null;
    status: MutualFeedbackRemovalStatus;
    /** @deprecated */
    statusText?: string | null;
}

export interface FeedbackItemApiDto {
    /** @format int32 */
    feedbackMemberId: number;
    feedbackMemberAlias?: string | null;
    feedbackMemberCountryCodeIso2?: string | null;
    feedbackMemberRole: FeedbackRoleApiDto;
    /** @format int32 */
    gradeId: number;
    rating: FeedbackRatingApiDto;
    text?: string | null;
    reply?: string | null;
    /** @format int32 */
    totalRating: number;
    /** @format date-time */
    created: string;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    itemCategoryId: number;
    itemShortDescription?: string | null;
    /** @format int32 */
    itemMaxBid: number;
    /** @format date-time */
    itemEndDate: string;
    mutualFeedbackRemovalItem?: MutualFeedbackRemovalItemApiDto | null;
}

export interface MemberFeedbackApiResponse {
    totalFeedbackSummary?: TotalFeedbackSummaryForMemberApiDto | null;
    detailedSellerRatingSummaryForMember?: DetailedSellerRatingSummaryForMemberApiDto | null;
    /** @format date-time */
    memberSince: string;
    accountState: MemberAccountState;
    responseStatus?: ResponseStatus | null;
    items?: FeedbackItemApiDto[] | null;
    /** @format int64 */
    totalCount: number;
}

export interface MemberDetails {
    /** @format int32 */
    id: number;
    alias?: string | null;
}

export enum FeedbackRemovalState {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected'
}

export interface MutualFeedbackRemovalApiDto {
    /** @format int32 */
    id: number;
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    transactionSellerMemberId: number;
    /** @format int32 */
    transactionBuyerMemberId: number;
    fromMember?: MemberDetails | null;
    toMember?: MemberDetails | null;
    comment?: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed?: string | null;
    status?: FeedbackRemovalState | null;
    /** @format int32 */
    itemId: number;
    isCompleted: boolean;
}

export enum TransactionFeedbackRole {
    Buyer = 'Buyer',
    Seller = 'Seller'
}

export enum TransactionFeedbackRating {
    None = 'None',
    Negative = 'Negative',
    Positive = 'Positive'
}

export interface TransactionFeedbackApiDto {
    /** @format int32 */
    fromMemberId: number;
    fromMemberAlias?: string | null;
    /** @format int32 */
    toMemberId: number;
    toMemberAlias?: string | null;
    memberRole: TransactionFeedbackRole;
    rating: TransactionFeedbackRating;
    text?: string | null;
    /** @format date-time */
    created: string;
}

export interface FeedbackRemovalApiResponse {
    responseStatus?: ResponseStatus | null;
    feedbackRemovalRequest?: MutualFeedbackRemovalApiDto | null;
    feedbacks?: TransactionFeedbackApiDto[] | null;
}

export interface ConfirmMutualFeedbackRemovalApiRequest {
    /** @format int32 */
    feedbackRemovalRequestId: number;
}

export interface ConfirmMutualFeedbackRemovalApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum ConfirmationStatus {
    ConfirmationAllowed = 'ConfirmationAllowed',
    RequestIsOlderThen30Days = 'RequestIsOlderThen30Days',
    RequestedBySubmitter = 'RequestedBySubmitter'
}

export interface ValidateConfirmationApiResponse {
    responseStatus?: ResponseStatus | null;
    feedbackRemovalRequest?: MutualFeedbackRemovalApiDto | null;
    feedbacks?: TransactionFeedbackApiDto[] | null;
    confirmationStatus: ConfirmationStatus;
}

export interface CreateFeedbackRemovalApiRequest {
    /** @format int32 */
    transactionId: number;
    comment?: string | null;
}

export interface CreateFeedbackRemovalApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum CreationStatus {
    CreationAllowed = 'CreationAllowed',
    CreatedBySubmitter = 'CreatedBySubmitter',
    CanBeAcceptedByReceiver = 'CanBeAcceptedByReceiver'
}

export interface ValidateCreationApiResponse {
    responseStatus?: ResponseStatus | null;
    feedbackRemovalRequest?: MutualFeedbackRemovalApiDto | null;
    feedbacks?: TransactionFeedbackApiDto[] | null;
    creationStatus: CreationStatus;
}

export interface DenyMutualFeedbackRemovalApiRequest {
    /** @format int32 */
    feedbackRemovalRequestId: number;
}

export interface DenyMututalFeedbackRemovalApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface FlowStatusRequest {
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    feedbackMemberId: number;
}

export interface FeedbackRemovalsApiRequest {
    feedbacks?: FlowStatusRequest[] | null;
}

export enum FeedbackRemovalFlowStatus {
    CanBeStarted = 'CanBeStarted',
    CanBeAccepted = 'CanBeAccepted',
    SubmittedAlready = 'SubmittedAlready',
    NotApplicable = 'NotApplicable'
}

export interface FlowStatusResponse {
    /** @format int32 */
    transactionId: number;
    feedbacksRemovalRequest?: MutualFeedbackRemovalApiDto | null;
    flowStatus: FeedbackRemovalFlowStatus;
}

export interface FeedbackRemovalsApiResponse {
    responseStatus?: ResponseStatus | null;
    feedbacksRemovalRequests?: FlowStatusResponse[] | null;
}

export interface MemberFeedbackItemsApiResponse {
    responseStatus?: ResponseStatus | null;
    items?: FeedbackItemApiDto[] | null;
    /** @format int64 */
    totalCount: number;
}

export interface MemberFeedbackSummaryApiResponse {
    totalFeedbackSummary?: TotalFeedbackSummaryForMemberApiDto | null;
    detailedSellerRatingSummary?: DetailedSellerRatingSummaryForMemberApiDto | null;
    /** @format date-time */
    memberSince: string;
    accountState: MemberAccountState;
    responseStatus?: ResponseStatus | null;
}

export interface TranslatedFeedbackItemApiDto {
    /** @format int32 */
    gradeId: number;
    text?: string | null;
    reply?: string | null;
}

export interface GetTranslatedMemberFeedbackApiResponse {
    items?: TranslatedFeedbackItemApiDto[] | null;
    isTranslationOnDemandDisabled: boolean;
    responseStatus?: ResponseStatus | null;
    providerName?: string | null;
}

export interface GetTransactionFeedbacksApiResponse {
    responseStatus?: ResponseStatus | null;
    feedbacks?: TransactionFeedbackApiDto[] | null;
}

export interface GetBraintreeInvoicePaymentApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    invoiceId: number;
    status?: string | null;
    orderId?: string | null;
    /** @format double */
    amount: number;
}

export interface CreditMemoByEncryptedIdApiResponse {
    /** @format byte */
    pdfFileContent?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetCreditMemoPdfApiResponse {
    /** @format byte */
    pdfFileContent?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetInvoiceCsvApiResponse {
    /** @format byte */
    csvFileContent?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetInvoicePdfApiResponse {
    /** @format byte */
    pdfFileContent?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreditMemoDto {
    /** @format int64 */
    invoiceId: number;
    creditMemoDocumentId?: string | null;
}

export interface InvoiceDto {
    /** @format int64 */
    invoiceId: number;
    /** @format date-time */
    invoiceDate: string;
    /** @format date-time */
    dueDate: string;
    /** @format double */
    invoiceAmount: number;
    /** @format double */
    amountOwed: number;
    /** @format int64 */
    ocr: number;
    paymentStatus?: string | null;
    creditMemos?: CreditMemoDto[] | null;
    csvGenerated: boolean;
}

export interface GetInvoicesApiResponse {
    invoices?: InvoiceDto[] | null;
    responseStatus?: ResponseStatus | null;
    isBillingUnderMaintenance: boolean;
    /** @format int64 */
    totalCount: number;
}

export interface UninvoicedFeeDto {
    /** @format int32 */
    feeId: number;
    /** @format date-time */
    createdDate: string;
    /** @format int32 */
    feeType: number;
    feeDescription?: string | null;
    /** @format double */
    amount: number;
    /** @format int32 */
    objectId: number;
    objectDescription?: string | null;
    /** @format int32 */
    revertedFeeRowId: number;
    /** @format int32 */
    creditedByFeeRowId: number;
    usersOwnReference?: string | null;
    /** @format date-time */
    originalFeeDate?: string | null;
    thumbUrl?: string | null;
    /** @format double */
    amountIncludingVat: number;
    itemIds?: number[] | null;
}

export interface GetUninvoicedFeesApiResponse {
    uninvoicedFees?: UninvoicedFeeDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalCount: number;
    /** @format double */
    totalAmountIncludingVat: number;
    invoiceCreating: boolean;
}

export interface MemberLoginDetailDto {
    alias?: string | null;
    hasTraderMessage: boolean;
    isCompanyUser: boolean;
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    totalRating: number;
    /** @format date-time */
    memberSince: string;
    accountState: MemberAccountState;
}

export interface FindMembersApiResponse {
    members?: MemberLoginDetailDto[] | null;
    /** @format int32 */
    totalCount: number;
    responseStatus?: ResponseStatus | null;
}

export type GetAvailableCountriesForShippingApiRequest = object;

export interface Country {
    countryNameSwe?: string | null;
    countryNameEng?: string | null;
    countryCodeIso2?: string | null;
}

export interface GetAvailableCountriesForShippingApiResponse {
    responseStatus?: ResponseStatus | null;
    availableCountries?: Country[] | null;
}

export interface GradeTransactionsApiResponse {
    gradesTransactions?: Record<string, number>;
    responseStatus?: ResponseStatus | null;
}

export interface GetImageUploadUrlApiResponse {
    signedUrl?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface SetItemVisibilityApiRequest {
    itemIds?: number[] | null;
    hidden: boolean;
}

export interface SetItemVisibilityApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface CompleteQuestionnaireApiRequest {
    /** @format int32 */
    questionnaireId: number;
    fieldValues?: Record<string, string[]>;
    languageCodeIso2?: string | null;
}

export interface CompleteQuestionnaireApiResponse {
    alias?: string | null;
    isValid: boolean;
    ruleViolations?: Record<string, string>;
    responseStatus?: ResponseStatus | null;
}

export interface InitializeQuestionnaireApiRequest {
    alias?: string | null;
}

export interface InitializeQuestionnaireApiResponse {
    /** @format int32 */
    questionnaireId: number;
    responseStatus?: ResponseStatus | null;
}

export type GetKycPendingActionsApiRequest = object;

export interface GetKycPendingActionsApiResponse {
    /** @format int32 */
    memberId: number;
    pendingActionActionTypes?: string[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface AnswerQuestionnaireApiRequest {
    alias?: string | null;
    fieldValues?: Record<string, string[]>;
    pageDefinitionWithValues?: string | null;
    languageCodeIso2?: string | null;
}

export interface AnswerQuestionnaireApiResponse {
    alias?: string | null;
    isValid: boolean;
    ruleViolations?: Record<string, string>;
    responseStatus?: ResponseStatus | null;
}

export interface GetKycQuestionnairePageDefinitionApiResponse {
    /** @format int32 */
    memberId: number;
    alias?: string | null;
    pageDefinition?: object | null;
    responseStatus?: ResponseStatus | null;
}

export type SetLastNotifiedApiRequest = object;

export interface SetLastNotifiedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum ItemTransactionTypeApiDto {
    Auction = 'Auction',
    Bin = 'Bin',
    Cart = 'Cart',
    PurchaseOfferOnActive = 'PurchaseOfferOnActive',
    PurchaseOfferOnEnded = 'PurchaseOfferOnEnded'
}

export interface ShippingApiDto {
    /** @format int32 */
    cost: number;
    type?: string | null;
    name?: string | null;
    isFreeShipping: boolean;
    isTakeaway: boolean;
    /** @format int32 */
    productId?: number | null;
    /** @format int32 */
    weight?: number | null;
    fromCountryCodeIso2?: string | null;
    toCountryCodeIso2?: string | null;
}

export interface DiscountDto {
    /** @format double */
    amount: number;
    /** @format date-time */
    created: string;
    type?: string | null;
}

export interface ItemTransactionApiDto {
    /** @format int32 */
    itemId: number;
    itemTransactionType: ItemTransactionTypeApiDto;
    /** @format int32 */
    itemCategoryId: number;
    itemTitle?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    sellerMemberId: number;
    sellerAlias?: string | null;
    /** @format int32 */
    buyerMemberId: number;
    /** @format int32 */
    itemPrice?: number | null;
    isPaid: boolean;
    /** @format int32 */
    transactionId: number;
    /** @format uuid */
    purchaseOrderId: string;
    hasBuyerLeftFeedback: boolean;
    hasSellerLeftFeedback: boolean;
    /** @format date-time */
    transactionDate: string;
    selectedShipping?: ShippingApiDto | null;
    /** @format int32 */
    orderNumber: number;
    trackingLink?: string | null;
    /** @format int32 */
    sellerRating: number;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    buyItNowPrice?: number | null;
    /** @format int32 */
    bidCount?: number | null;
    isHidden: boolean;
    discounts?: DiscountDto[] | null;
    paidStatus?: string | null;
    hasTraderaAsMerchantOfRecord: boolean;
    isPaynovaPayment: boolean;
}

export interface GetAllItemsForLeaveFeedbackAsBuyerApiResponse {
    items?: ItemTransactionApiDto[] | null;
    /** @format int64 */
    itemsLeft: number;
    /** @format int64 */
    totalCount: number;
    /** @format int64 */
    paidTotalCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetItemsForLeaveFeedbackAsBuyerApiResponse {
    transactions?: ItemTransactionApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface ItemImageUrls {
    normal?: string | null;
    medium?: string | null;
}

export interface MemberContactDetailsApiDto {
    /** @format int32 */
    memberId: number;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
    country?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    alias?: string | null;
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    countryCodeIso2?: string | null;
}

export interface BookedShipping {
    /** @format uuid */
    shipmentId: string;
    /** @format uuid */
    shipmentCheckoutId: string;
    trackingLink?: string | null;
    trackingId?: string | null;
    shippingType?: string | null;
    hasShipmentLabel: boolean;
    hasShipmentReceipt: boolean;
}

export interface ShippingDiscount {
    shippingProvider?: string | null;
    /** @format int32 */
    price: number;
}

export interface MemberSoldItemApiDto {
    /** @format uuid */
    purchaseOrderId: string;
    /** @format int32 */
    transactionId: number;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    categoryId: number;
    itemTitle?: string | null;
    mainImage?: ItemImageUrls | null;
    mainImageTemplate?: string | null;
    /** @format int32 */
    price: number;
    /** @format int32 */
    fixedPrice?: number | null;
    /** @format int32 */
    reservedPrice?: number | null;
    hasBuyerLeftFeedback: boolean;
    hasSellerLeftFeedback: boolean;
    isMarkedAsPaidByBuyer: boolean;
    isMarkedAsPaidBySeller: boolean;
    isMarkedAsShipped: boolean;
    isShippingBooked: boolean;
    /** @format date-time */
    transactionDate: string;
    buyerMemberAlias?: string | null;
    /** @format int32 */
    buyerMemberId: number;
    hiddenBySeller: boolean;
    /** @deprecated */
    trackingLink?: string | null;
    itemTransactionType: ItemTransactionTypeApiDto;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    bidCount?: number | null;
    buyerContactDetails?: MemberContactDetailsApiDto | null;
    selectedShipping?: ShippingApiDto | null;
    offeredShippingOptions?: ShippingApiDto[] | null;
    bookedShipping?: BookedShipping | null;
    shippingDiscount?: ShippingDiscount | null;
    userReference?: string | null;
    soldItemState?: string | null;
    /** @format int32 */
    leadingBid?: number | null;
    /** @format int32 */
    buyerTotalRating: number;
    paidStatus?: string | null;
    /** @deprecated */
    paymentProvider?: string | null;
    discounts?: DiscountDto[] | null;
    isDiscountAfterPaymentSupported: boolean;
    isDiscountBeforePaymentSupported: boolean;
    /** @deprecated */
    isPaidWithIntegratedPaymentOption: boolean;
}

export interface GetAllItemsForLeaveFeedbackAsSellerApiResponse {
    items?: MemberSoldItemApiDto[] | null;
    /** @format int64 */
    itemsLeft: number;
    /** @format int64 */
    totalCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetItemsForLeaveFeedbackAsSellerApiResponse {
    items?: MemberSoldItemApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface LeaveFeedbackAsBuyerApiResponse {
    transaction?: ItemTransactionApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface SaveFeedbackAsBuyerApiRequest {
    /** @format int32 */
    transactionId: number;
    isPositive: boolean;
    comment?: string | null;
    /** @format int32 */
    itemAsDescribed?: number | null;
    /** @format int32 */
    commResponsiveness?: number | null;
    /** @format int32 */
    shippingTime?: number | null;
    /** @format int32 */
    shippingHandlingCharges?: number | null;
    reportInr: boolean;
    /**
     * @deprecated
     * @format int32
     */
    sellerMemberId: number;
    /**
     * @deprecated
     * @format int32
     */
    itemId: number;
}

export interface SaveFeedbackAsBuyerApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface CommentFeedbackApiRequest {
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    gradeId: number;
    comment?: string | null;
}

export interface CommentFeedbackApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface LeaveFeedbackAsSellerApiResponse {
    transaction?: ItemTransactionApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface SaveFeedbackAsSellerApiRequest {
    /** @format int32 */
    transactionId: number;
    isPositive: boolean;
    comment?: string | null;
    /** @format int32 */
    paymentTime?: number | null;
    /**
     * @deprecated
     * @format int32
     */
    itemId: number;
    /**
     * @deprecated
     * @format int32
     */
    buyerMemberId: number;
}

export interface SaveFeedbackAsSellerApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type MemberListSettingsApiRequest = object;

export interface MemberListSettingsApiResponse {
    /** @format int32 */
    memberId: number;
    publicMemoryList: boolean;
    enablePublicSavedSearch: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface StrikeItem {
    /** @format int32 */
    transactionId: number;
}

export interface MutualCancelOfPurchaseStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
    strikeSubmitted: boolean;
    strikeConfirmed: boolean;
    /** @format uuid */
    purchaseOrderId: string;
    items?: StrikeItem[] | null;
}

export interface AddMutualCancelOfPurchaseStrikeApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    comment?: string | null;
}

export interface AddMutualCancelOfPurchaseStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ConfirmMutualCancelOfPurchaseStrikeApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    approved: boolean;
}

export interface ConfirmMutualCancelOfPurchaseStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetMemberEmailNotificationsSettingsViewModelApiRequest = object;

export interface MemberEmailNotificationsSettingsMessagingApiDto {
    isAllowedToSetParticipation: boolean;
    participates: boolean;
    emailNotifyAll: boolean;
}

export interface MemberEmailNotificationsSettingsEmailApiDto {
    notifyWhenItemBecomesUnsold: boolean;
    notifyOnFirstWinningBid: boolean;
    notifyBeforeWishListItemEnds: boolean;
    acceptsNewsLetter: boolean;
    acceptsOfferEmails: boolean;
    acceptsUpiInfoEmails: boolean;
    acceptsUnknownDeviceOrIpEmails: boolean;
}

export interface GetMemberEmailNotificationsSettingsViewModelApiResponse {
    /** @format int32 */
    memberId: number;
    messaging?: MemberEmailNotificationsSettingsMessagingApiDto | null;
    email?: MemberEmailNotificationsSettingsEmailApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export type GetMemberProfileSettingsViewModelApiRequest = object;

export interface HeroImageUrlApiDto {
    max?: string | null;
    med?: string | null;
    min?: string | null;
}

export interface MemberProfileSettingsPresentationApiDto {
    heroImageUrls?: HeroImageUrlApiDto | null;
    information?: string | null;
}

export interface MemberProfileSettingsAccountInformationApiDto {
    alias?: string | null;
    emailAddress?: string | null;
}

export interface MemberProfileSettingsPersonalDataApiDto {
    firstName?: string | null;
    lastName?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    countryCodeIso2?: string | null;
    phoneNumber?: string | null;
    phoneNumberUnvalidated?: string | null;
    isNameChangeAllowed: boolean;
}

export interface GetMemberProfileSettingsViewModelApiResponse {
    /** @format int32 */
    memberId: number;
    presentation?: MemberProfileSettingsPresentationApiDto | null;
    accountInformation?: MemberProfileSettingsAccountInformationApiDto | null;
    personalData?: MemberProfileSettingsPersonalDataApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export type GetMemberSecuritySettingsViewModelApiRequest = object;

export interface MemberSecuritySettingsAccountDeactivationApiDto {
    isAccountDeactivationAllowed: boolean;
}

export interface MemberSecuritySettingsBlockedMemberApiDto {
    /** @format int32 */
    memberId: number;
    alias?: string | null;
}

export interface MemberSecuritySettingsMemberBlockingApiDto {
    blockedMembers?: MemberSecuritySettingsBlockedMemberApiDto[] | null;
}

export interface GetMemberSecuritySettingsViewModelApiResponse {
    /** @format int32 */
    memberId: number;
    accountDeactivation?: MemberSecuritySettingsAccountDeactivationApiDto | null;
    memberBlocking?: MemberSecuritySettingsMemberBlockingApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export type GetMemberSellerSettingsViewModelApiRequest = object;

export interface MemberSellerSettingsCombinedShippingApiDto {
    enabled: boolean;
    /** @format int32 */
    days: number;
    isChangeAllowed: boolean;
}

export interface MemberSellerSettingsShippingFeeRuleApiDto {
    shippingOption?: string | null;
    useFreeShippingCostLimit: boolean;
    /** @format int32 */
    freeShippingCostLimit: number;
}

export interface MemberSellerSettingsCommitOnPaymentApiDto {
    enabled: boolean;
    isChangeAllowed: boolean;
}

export enum SellerAutoFeedbackType {
    Manual = 'Manual',
    PositiveFeedback = 'PositiveFeedback',
    Paid = 'Paid'
}

export interface MemberSellerSettingsAutoFeedbackApiDto {
    enabled: boolean;
    type: SellerAutoFeedbackType;
    message?: string | null;
}

export interface MemberSellerSettingsAutoPaymentReminderApiDto {
    enabled: boolean;
}

export interface MemberSellerSettingsAutoShipmentCheckoutApiDto {
    enabled: boolean;
    isChangeAllowed: boolean;
}

export interface MemberSellerSettingsItemLocalizationApiDto {
    shippingFromCountryCodeIso2?: string | null;
    selectedDescriptionLanguageCodeIso2?: string | null;
}

export interface GetMemberSellerSettingsViewModelApiResponse {
    /** @format int32 */
    memberId: number;
    combinedShipping?: MemberSellerSettingsCombinedShippingApiDto | null;
    shippingFeeRule?: MemberSellerSettingsShippingFeeRuleApiDto | null;
    commitOnPayment?: MemberSellerSettingsCommitOnPaymentApiDto | null;
    autoFeedback?: MemberSellerSettingsAutoFeedbackApiDto | null;
    autoPaymentReminder?: MemberSellerSettingsAutoPaymentReminderApiDto | null;
    autoShipmentCheckout?: MemberSellerSettingsAutoShipmentCheckoutApiDto | null;
    itemLocalization?: MemberSellerSettingsItemLocalizationApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export enum MessagingEmailNotification {
    All = 'All',
    Unread = 'Unread',
    None = 'None'
}

export interface GetMessagingEmailNotifyApiResponse {
    /** @format int32 */
    memberId: number;
    emailNotify: MessagingEmailNotification;
    responseStatus?: ResponseStatus | null;
}

export interface SetMessagingEmailNotifyApiRequest {
    emailNotify: MessagingEmailNotification;
}

export interface SetMessagingEmailNotifyApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetMessagingMyParticipationApiRequest = object;

export interface GetMessagingMyParticipationApiResponse {
    /** @format int32 */
    memberId: number;
    participates: boolean;
    allowedToSet: boolean;
    suspended: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface GetMessagingParticipationApiResponse {
    /** @format int32 */
    memberId: number;
    participates: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface SetMessagingParticipationApiRequest {
    participates: boolean;
}

export interface SetMessagingParticipationApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetMessagingStatsApiRequest = object;

export interface GetMessagingStatsApiResponse {
    /** @format int32 */
    threads: number;
    /** @format int32 */
    threadsUnread: number;
    responseStatus?: ResponseStatus | null;
}

export interface NotificationApiDto {
    /** @format int32 */
    memberId: number;
    type?: string | null;
    /** @format int32 */
    itemId: number;
    title?: string | null;
    /** @format int32 */
    amount: number;
    /** @format date-time */
    timeStamp: string;
    isRead: boolean;
    mainImage?: ItemImageUrls | null;
    mainImageTemplate?: string | null;
}

export interface GetNotificationsApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    unreadCount: number;
    /** @format int64 */
    totalCount: number;
    items?: NotificationApiDto[] | null;
}

export interface OrderItem {
    /** @format int32 */
    itemId: number;
    /** @format double */
    price: number;
    shortDescription?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format date-time */
    transactionDate: string;
}

export interface PublicProfileApiDto {
    /** @format int32 */
    memberId: number;
    alias?: string | null;
    /** @format double */
    detailedSellerRating?: number | null;
    /** @format int32 */
    totalRating: number;
    isCompanyUser: boolean;
    hasShop: boolean;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
}

export interface ContactDetailsApiDto {
    /** @format int32 */
    memberId: number;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
    country?: string | null;
    fullName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    alias?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    countryCodeIso2?: string | null;
}

export interface PaymentOptionApiDto {
    displayName?: string | null;
    paymentType?: string | null;
}

export interface BuyerProtectionApiDto {
    /** @format double */
    buyerProtectionCost: number;
}

export interface OrderInfoApiResponse {
    responseStatus?: ResponseStatus | null;
    items?: OrderItem[] | null;
    sellerProfile?: PublicProfileApiDto | null;
    sellerContactDetails?: ContactDetailsApiDto | null;
    paymentOptions?: PaymentOptionApiDto[] | null;
    paidStatus?: string | null;
    paymentMethod?: string | null;
    /** @format uuid */
    purchaseOrderId: string;
    /** @format int32 */
    transactionId: number;
    offeredShippingOptions?: ShippingApiDto[] | null;
    selectedShipping?: ShippingApiDto | null;
    bookedShipping?: BookedShipping | null;
    shippingDiscount?: ShippingDiscount | null;
    isMarkedAsShipped: boolean;
    isFeedbackLeftByBuyer: boolean;
    discounts?: DiscountDto[] | null;
    /** @format double */
    totalOrderPrice: number;
    /** @format double */
    totalOrderPriceWithoutShipping: number;
    buyerProtection?: BuyerProtectionApiDto | null;
}

export type RemoveBankAccountPayoutTransferMethodApiRequest = object;

export interface RemoveBankAccountPayoutTransferMethodApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetBankAccountPayoutTransferMethodApiRequest {
    clearingNumber?: string | null;
    bankAccountNumber?: string | null;
}

export interface SetBankAccountPayoutTransferMethodApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format uuid */
    processCorrelationId: string;
    errorCode?: string | null;
}

export interface CompleteHyperwalletTransferMethodApiRequest {
    transferMethodToken?: string | null;
    transferMethodType?: string | null;
}

export interface CompleteHyperwalletTransferMethodApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetHyperwalletAuthenticationTokenApiRequest = object;

export interface GetHyperwalletAuthenticationTokenApiResponse {
    authenticationToken?: string | null;
    responseStatus?: ResponseStatus | null;
}

export type GetHyperwalletTransferMethodViewModelApiRequest = object;

export interface GetHyperwalletTransferMethodViewModelApiResponse {
    userToken?: string | null;
    widgetBaseUrl?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface MatchBankApiRequest {
    bankAccountNumber?: string | null;
    clearingNumber?: string | null;
}

export interface MatchBankApiResponse {
    bankName?: string | null;
    ok: boolean;
    clearingNumber?: string | null;
    bankAccountNumber?: string | null;
    responseStatus?: ResponseStatus | null;
    requireBankIdVerification: boolean;
}

export type GetMemberPayoutSettingsViewModelApiRequest = object;

export interface MemberPayoutSettingsMember {
    /** @format int32 */
    memberId: number;
    isCompany: boolean;
    emailAddress?: string | null;
    phoneNumber?: string | null;
}

export interface MemberPayoutSettingsPayoutDestination {
    type?: string | null;
    transferMethodToken?: string | null;
    country?: string | null;
    currency?: string | null;
    emailAddress?: string | null;
    clearingNumber?: string | null;
    bankAccountNumber?: string | null;
    swift?: string | null;
    iban?: string | null;
}

export interface MemberPayoutSettingsPayoutProblem {
    type?: string | null;
    details?: string | null;
}

export interface MemberPayoutSettingsSwishApp2App {
    swishNumber?: string | null;
}

export interface MemberPayoutSettingsTink {
    tinkLinkUrl?: string | null;
}

export interface MemberPayoutSettingsHyperwallet {
    userToken?: string | null;
    widgetBaseUrl?: string | null;
}

export interface MemberPayoutSettingsTraderaPay {
    payoutProvider?: string | null;
    payoutDestination?: MemberPayoutSettingsPayoutDestination | null;
    payoutProblems?: MemberPayoutSettingsPayoutProblem[] | null;
    swishApp2App?: MemberPayoutSettingsSwishApp2App | null;
    tink?: MemberPayoutSettingsTink | null;
    hyperwallet?: MemberPayoutSettingsHyperwallet | null;
}

export interface GetMemberPayoutSettingsViewModelApiResponse {
    member?: MemberPayoutSettingsMember | null;
    traderaPay?: MemberPayoutSettingsTraderaPay | null;
    responseStatus?: ResponseStatus | null;
}

export type RemovePayPalPayoutTransferMethodApiRequest = object;

export interface RemovePayPalPayoutTransferMethodApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetPayPalPayoutTransferMethodApiRequest {
    emailAddress?: string | null;
}

export interface SetPayPalPayoutTransferMethodApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format uuid */
    processCorrelationId: string;
    errorCode?: string | null;
}

export type SetHyperwalletPayeeVerificationAsSubmittedApiRequest = object;

export interface SetHyperwalletPayeeVerificationAsSubmittedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetPayoutTransferMethodUsingTinkApiRequest {
    accountNumber?: string | null;
}

export interface SetPayoutTransferMethodUsingTinkApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format uuid */
    processCorrelationId: string;
    errorCode?: string | null;
}

export interface GetPayoutTransferMethodUpdateStatusApiResponse {
    responseStatus?: ResponseStatus | null;
    status?: string | null;
    errorCode?: string | null;
}

export interface ItemStrikeSubmission {
    /** @format int32 */
    transactionId: number;
    strikeSubmitted: boolean;
}

export interface PurchaseOrderNotReceivedStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
    strikeSubmitted: boolean;
    items?: ItemStrikeSubmission[] | null;
}

export interface AddPurchaseOrderNotReceivedStrikeApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    comment?: string | null;
}

export interface AddPurchaseOrderNotReceivedStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface BankIdPasswordRecoveryCancelApiRequest {
    bankIdOrderRef?: string | null;
    /** @format int32 */
    memberid: number;
}

export interface BankIdAuthenticationCancelApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface BankIdAuthenticationProgressApiResponse {
    isCompleted: boolean;
    progress?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface BankIdBeginWithIdApiRequest {
    /** @format int32 */
    memberId: number;
}

export interface BankIdAuthenticationBeginApiResponse {
    bankIdOrderRef?: string | null;
    responseStatus?: ResponseStatus | null;
    autoStartToken?: string | null;
}

export enum VerificationReason {
    VerificationNotNeeded = 'VerificationNotNeeded',
    NeedInitialVerification = 'NeedInitialVerification',
    NeedsVerificationFixedPriceLimitTwoMonthValidation = 'NeedsVerificationFixedPriceLimitTwoMonthValidation',
    NeedsVerificationFixedPriceLimitExpensive = 'NeedsVerificationFixedPriceLimitExpensive'
}

export interface GetMemberBankIdVerificationApiResponse {
    responseStatus?: ResponseStatus | null;
    needInitialVerification: boolean;
    supportsVerification: boolean;
    /** @format date-time */
    lastVerifiedDate: string;
    /** @format date-time */
    manualIdentityVerificationValidTo: string;
    bankIdFormattedPersonalNumber?: string | null;
    needsVerification: boolean;
    verificationReason: VerificationReason;
}

export type GetBraintreeOnboardingDetailsApiRequest = object;

export interface GetBraintreeOnboardingDetailsApiResponse {
    responseStatus?: ResponseStatus | null;
    isEnabled: boolean;
    isAccountDetailsSupplied: boolean;
    maskedBankAccount?: string | null;
    isAlreadyOnboarded: boolean;
    isOnboardingAllowed: boolean;
}

export interface ChangeAliasApiRequest {
    newAlias?: string | null;
    ipAddress?: string | null;
    operatingSystem?: string | null;
    browser?: string | null;
    location?: string | null;
}

export interface ChangeAliasApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ChangeEmailWithIdApiRequest {
    bankIdOrderRef?: string | null;
    /** @format int32 */
    memberId: number;
    email?: string | null;
    userIpAddress?: string | null;
}

export interface ChangeEmailWithIdApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ChangePasswordApiRequest {
    password?: string | null;
}

export interface ChangePasswordApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ChangePasswordWithIdApiRequest {
    /** @format int32 */
    memberId: number;
    password?: string | null;
}

export interface SetMemberConsentApiRequest {
    agreementName?: string | null;
}

export interface SetMemberConsentApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type CreateVerificationCodeApiRequest = object;

export interface CreateVerificationCodeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum RecoveryFlowType {
    Email = 'Email',
    Sms = 'Sms'
}

export interface CreateVerificationCodeWithMemberIdApiRequest {
    /** @format int32 */
    memberId: number;
    recoveryFlowType: RecoveryFlowType;
}

export interface CreateVerificationCodeWithMemberIdApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberCurrencyApiRequest {
    currencyCode?: string | null;
}

export interface UpdateMemberCurrencyApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetHyperwalletMemberDetailsApiRequest = object;

export interface GetHyperwalletMemberDetailsApiResponse {
    responseStatus?: ResponseStatus | null;
    userToken?: string | null;
    payeeVerificationStatus?: string | null;
}

export type GetIsCombinedShippingEnabledApiRequest = object;

export interface GetIsCombinedShippingEnabledApiResponse {
    responseStatus?: ResponseStatus | null;
    isEnabled: boolean;
}

export type GetIsTraderaPayEnabledApiRequest = object;

export interface GetIsTraderaPayEnabledApiResponse {
    responseStatus?: ResponseStatus | null;
    isEnabled: boolean;
}

export type GetShippingInvoiceMemberApiRequest = object;

export interface GetShippingInvoiceMemberApiResponse {
    responseStatus?: ResponseStatus | null;
    enabled: boolean;
}

export type GetTraderaPayMemberApiRequest = object;

export enum SwishApp2AppMemberDetailsState {
    Step1 = 'Step1',
    Step2 = 'Step2',
    Step3 = 'Step3'
}

export interface SwishApp2AppMemberDetailsDto {
    phoneNumber?: string | null;
    /** @format date-time */
    verified?: string | null;
    enabled: boolean;
    optOut: boolean;
    suggestedPhoneNumber?: string | null;
    state: SwishApp2AppMemberDetailsState;
}

export interface BraintreeMemberDetailsDto {
    enabled: boolean;
    maskedBankAccountNumber?: string | null;
    isBankAccountSupplied: boolean;
    /** @format date-time */
    created: string;
    hasFailedPayouts: boolean;
    isMemberSetForPayout: boolean;
    isOnboardedToLicense: boolean;
}

export interface HyperwalletPayeeVerificationDetailsDto {
    status?: string | null;
    /** @format date-time */
    statusCreatedOn?: string | null;
    /** @format date-time */
    submitted?: string | null;
}

export interface GetTraderaPayMemberApiResponse {
    responseStatus?: ResponseStatus | null;
    swishApp2AppMemberMemberDetails?: SwishApp2AppMemberDetailsDto | null;
    braintreeMemberDetails?: BraintreeMemberDetailsDto | null;
    hyperwalletPayeeVerificationDetails?: HyperwalletPayeeVerificationDetailsDto | null;
}

export type GetTraderaPayOnboardingDetailsApiRequest = object;

export enum OnboardingType {
    None = 'None',
    Normal = 'Normal',
    Aggressive = 'Aggressive'
}

export interface GetTraderaPayOnboardingDetailsApiResponse {
    onboardingType: OnboardingType;
    isSwishNumberSupplied: boolean;
    isBankAccountDetailsSupplied: boolean;
    hasSellerActivity: boolean;
    responseStatus?: ResponseStatus | null;
}

export type GetHasWalletApiRequest = object;

export interface GetHasWalletApiResponse {
    responseStatus?: ResponseStatus | null;
    hasWallet: boolean;
    isFeeNettingEnabled: boolean;
    isOnboardedToFeeNetting: boolean;
    isFeeNettingReminderPostponed: boolean;
}

export interface UpdateMemberLanguageApiRequest {
    languageCodeIso2?: string | null;
    userIpAddress?: string | null;
}

export interface UpdateMemberLanguageApiResponse {
    responseStatus?: ResponseStatus | null;
    isValid: boolean;
}

export interface MemberIdentificationBankIdPasswordRecoveryCancelApiRequest {
    bankIdOrderRef?: string | null;
    /** @format int32 */
    memberid: number;
}

export interface MemberIdentificationBeginBankIdWithIdApiRequest {
    /** @format int32 */
    memberId: number;
}

export interface MemberIdentificationChangeEmailWithIdApiRequest {
    bankIdOrderRef?: string | null;
    /** @format int32 */
    memberId: number;
    email?: string | null;
    userIpAddress?: string | null;
}

export type GetMemberLocalizationApiRequest = object;

export interface GetMemberLocalizationApiResponse {
    responseStatus?: ResponseStatus | null;
    languageCodeIso2?: string | null;
    currencyCode?: string | null;
    automaticTranslationPreference: boolean;
}

export type GetMemberConsentApiRequest = object;

export interface GetMemberConsentApiResponse {
    responseStatus?: ResponseStatus | null;
    hasTraderaPayConsent: boolean;
    isUnderLicense: boolean;
    needsConsentOfTraderaPayAgreement?: string | null;
}

export type GetPayoutFrequencyApiRequest = object;

export interface PayoutFrequencyApiResponse {
    payoutFrequencyOption?: string | null;
    responseStatus?: ResponseStatus | null;
}

export type GetPayoutFrequencyOptionsApiRequest = object;

export interface PayoutFrequencyOptionsApiResponse {
    options?: string[] | null;
    responseStatus?: ResponseStatus | null;
}

export type RemoveTraderaPayPayoutDestinationApiRequest = object;

export interface RemoveTraderaPayPayoutDestinationApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberSelectedDescriptionLanguageApiRequest {
    languageCodeIso2?: string | null;
}

export interface UpdateMemberSelectedDescriptionLanguageApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetPayoutFrequencyApiRequest {
    payoutFrequencyOption?: string | null;
}

export interface SetPayoutFrequencyApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberShippingFromCountryApiRequest {
    countryCodeIso2?: string | null;
}

export interface UpdateMemberShippingFromCountryApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SmsCheckApiRequest {
    smsSid?: string | null;
}

export interface SmsCheckApiResponse {
    responseStatus?: ResponseStatus | null;
    successful: boolean;
}

export interface SendVerificationSmsApiRequest {
    cellphoneNumber?: string | null;
    countryCode?: string | null;
}

export interface SendVerificationSmsApiResponse {
    responseStatus?: ResponseStatus | null;
    successful: boolean;
    errorMessage?: string | null;
    sentToTelephoneNumber?: string | null;
    sentToCountryCode?: string | null;
    smsSid?: string | null;
}

export interface SmsVerificationDTO {
    cellphoneNumber?: string | null;
    /** @format date-time */
    timestamp: string;
    action?: string | null;
}

export interface SmsVerificationsApiResponse {
    verifications?: SmsVerificationDTO[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface SendVerificationSmsWithIdApiRequest {
    /** @format int32 */
    memberId: number;
    cellphoneNumber?: string | null;
    countryCode?: string | null;
    recoveryFlowType: RecoveryFlowType;
}

export type SwishApp2AppMemberDisableApiRequest = object;

export interface SwishApp2AppMemberDisableApiResponse {
    responseStatus?: ResponseStatus | null;
    ok: boolean;
}

export type SwishApp2AppMemberOptOutApiRequest = object;

export interface SwishApp2AppMemberOptOutApiResponse {
    responseStatus?: ResponseStatus | null;
    ok: boolean;
}

export interface SwishApp2AppMemberSavePhoneNumberApiRequest {
    phoneNumber?: string | null;
}

export interface SwishApp2AppMemberSavePhoneNumberApiResponse {
    ok: boolean;
    responseStatus?: ResponseStatus | null;
    requireSmsVerification: boolean;
    requireBankIdVerification: boolean;
}

export interface SwishApp2AppMemberSetVerifiedApiRequest {
    code?: string | null;
}

export interface SwishApp2AppMemberSetVerifiedApiResponse {
    responseStatus?: ResponseStatus | null;
    ok: boolean;
}

export interface SwishApp2AppMemberVerifyCodeApiRequest {
    code?: string | null;
}

export interface SwishApp2AppMemberVerifyCodeApiResponse {
    responseStatus?: ResponseStatus | null;
    ok: boolean;
}

export interface TinkBankAccountDto {
    bankId?: string | null;
    name?: string | null;
    accountNumber?: string | null;
    icon?: string | null;
}

export interface TinkGetBankAccountsApiResponse {
    responseStatus?: ResponseStatus | null;
    accounts?: TinkBankAccountDto[] | null;
}

export type TinkGetLinkApiRequest = object;

export interface TinkGetLinkApiResponse {
    responseStatus?: ResponseStatus | null;
    url?: string | null;
}

export interface UpdateMemberTranslationPreferenceApiRequest {
    isAutomaticTranslationPreferenceEnabled: boolean;
}

export interface UpdateMemberTranslationPreferenceApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ValidateExistingPasswordForMemberApiRequest {
    existingPassword?: string | null;
}

export interface ValidateExistingPasswordForMemberApiResponse {
    isValid: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface VerifyNonMobilePincodeApiRequest {
    pincode?: string | null;
}

export interface VerifyPincodeApiResponse {
    success: boolean;
    hasActiveVerificationCode: boolean;
    /** @format int32 */
    verificationAttempts: number;
    responseStatus?: ResponseStatus | null;
}

export interface VerifyNonMobilePincodeWithIdApiRequest {
    /** @format int32 */
    memberId: number;
    pincode?: string | null;
    recoveryFlowType: RecoveryFlowType;
}

export interface VerifyPincodeApiRequest {
    pincode?: string | null;
}

export interface VerifyPincodeWithIdApiRequest {
    /** @format int32 */
    memberId: number;
    pincode?: string | null;
    recoveryFlowType: RecoveryFlowType;
}

export interface RemoveMemberPublicProfileHeroImageApiRequest {
    userIpAddress?: string | null;
}

export interface RemoveMemberPublicProfileHeroImageApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberPublicProfileHeroImageApiRequest {
    heroImageUrl?: string | null;
    userIpAddress?: string | null;
}

export interface UpdateMemberPublicProfileHeroImageApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberPublicProfileInformationApiRequest {
    information?: string | null;
    userIpAddress?: string | null;
}

export interface UpdateMemberPublicProfileInformationApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum WishListStatusFilter {
    All = 'All',
    Active = 'Active',
    Ended = 'Ended'
}

export interface MemberBidInfo {
    /** @format int32 */
    maxBidAmount: number;
    bidRemoved: boolean;
    auctionRemoved: boolean;
    reservePriceReached: boolean;
    /** @format int32 */
    memberId: number;
}

export enum ItemTypeApiDto {
    Auction = 'Auction',
    AuctionBin = 'AuctionBin',
    PureBin = 'PureBin',
    ShopItem = 'ShopItem'
}

export interface WishListItemDto {
    /** @format int32 */
    itemId: number;
    title?: string | null;
    /** @format int32 */
    categoryId: number;
    /** @format date-time */
    endDate: string;
    isShopItem: boolean;
    /** @format int32 */
    currentBidAmount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    nextValidBidAmount?: number | null;
    /** @format int32 */
    leadingBidMemberId?: number | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    fixedPrice: number;
    hasEnded: boolean;
    isBuyItNow: boolean;
    preferredShipping?: ShippingApiDto | null;
    sellerAlias?: string | null;
    /** @format int32 */
    sellerTotalRating: number;
    /** @format int32 */
    sellerMemberId: number;
    /** @format date-time */
    addedToWishList: string;
    memberBid?: MemberBidInfo | null;
    /** @format int32 */
    transactionType?: number | null;
    isPaid?: boolean | null;
    /** @format int32 */
    itemPrice?: number | null;
    /** @format date-time */
    transactionDate?: string | null;
    boughtByCurrentMember: boolean;
    hasReservePrice: boolean;
    reservePriceReached: boolean;
    displayHighlighted: boolean;
    type: ItemTypeApiDto;
    mainImage?: ItemImageUrls | null;
    mainImageTemplate?: string | null;
    secondaryImage?: ItemImageUrls | null;
    secondaryImageTemplate?: string | null;
    hasCommitUpFront: boolean;
}

export interface GetWishListApiResponse {
    wishListItems?: WishListItemDto[] | null;
    /** @format int32 */
    totalCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface PublicProfileApiResponse {
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    totalRating: number;
    alias?: string | null;
    isCompanyUser: boolean;
    city?: string | null;
    firstName?: string | null;
    shopLogoUrl?: string | null;
    hasShop: boolean;
    isSwedishUser: boolean;
    /** @format float */
    detailedSellerRatingAverage?: number | null;
    /** @format date-time */
    memberSince: string;
    responseStatus?: ResponseStatus | null;
    heroImage?: string | null;
    information?: string | null;
    accountState: MemberAccountState;
    /** @format int32 */
    combinedShippingDays: number;
    selectedDescriptionLanguageCodeIso2?: string | null;
    shippingFromCountryCodeIso2?: string | null;
    translatedInformation?: string | null;
}

export interface MemberPurchaseApiResponse {
    item?: ItemTransactionApiDto | null;
    seller?: MemberContactDetailsApiDto | null;
    buyer?: MemberContactDetailsApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface MemberPurchaseOrderApiResponse {
    items?: ItemTransactionApiDto[] | null;
    seller?: ContactDetailsApiDto | null;
    buyer?: ContactDetailsApiDto | null;
    paymentMethod?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface MemberPurchaseOrderItemApiResponse {
    items?: ItemTransactionApiDto[] | null;
    paymentMethod?: string | null;
    responseStatus?: ResponseStatus | null;
}

export enum SellerAutoFeedbackCriteria {
    Manual = 'Manual',
    PositiveFeedback = 'PositiveFeedback',
    Paid = 'Paid'
}

export interface SaveSellerAutoFeedbackSettingsApiRequest {
    message?: string | null;
    criteria: SellerAutoFeedbackCriteria;
}

export interface SaveSellerAutoFeedbackSettingsApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type SellerAutoFeedbackApiRequest = object;

export interface SellerAutoFeedbackApiResponse {
    message?: string | null;
    criteria: SellerAutoFeedbackCriteria;
    /** @format date-time */
    created: string;
    responseStatus?: ResponseStatus | null;
}

export interface SaveSellerAutoPaymentReminderSettingsApiRequest {
    enabled: boolean;
}

export interface SaveSellerAutoPaymentReminderSettingsApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type SellerAutoPaymentReminderApiRequest = object;

export interface SellerAutoPaymentReminderApiResponse {
    enabled: boolean;
    responseStatus?: ResponseStatus | null;
}

export type MemberActiveItemsSummaryApiRequest = object;

export interface MemberActiveItemsSummaryApiDto {
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    sumOpeningBids: number;
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    shopItemCount: number;
}

export interface MemberActiveItemsSummaryApiResponse {
    summary?: MemberActiveItemsSummaryApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface FeatureSummaryApiDto {
    name?: string | null;
    /** @format int32 */
    cost: number;
    /** @format int32 */
    count: number;
}

export interface CampaignCodeItem {
    /** @format int32 */
    campaignCodeId: number;
    campaignCode?: string | null;
    auctionId?: number[] | null;
}

export interface FeatureSummaryByIdsApiResponse {
    featureSummaryList?: FeatureSummaryApiDto[] | null;
    isCompanyUser: boolean;
    campaignCodes?: CampaignCodeItem[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface SetItemShippedApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    shipped: boolean;
}

export interface SetItemShippedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetItemShippingBookedApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    booked: boolean;
}

export interface SetItemShippingBookedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface MarkAsPaidBySellerApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    paidConfirmed: boolean;
}

export interface MarkAsPaidBySellerApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum PickListFilterPaidStatus {
    All = 'All',
    Paid = 'Paid',
    Unpaid = 'Unpaid'
}

export enum PickListFilterShippedStatus {
    All = 'All',
    Shipped = 'Shipped',
    NotShipped = 'NotShipped'
}

export interface PickListBuyerApiDto {
    /** @format int32 */
    buyerMemberId: number;
    buyerMemberAlias?: string | null;
    /** @format int32 */
    feedbackCount: number;
    buyerContactDetails?: MemberContactDetailsApiDto | null;
    items?: MemberSoldItemApiDto[] | null;
}

export interface MemberPickListApiResponse {
    /** @format int32 */
    hiddenCount: number;
    items?: PickListBuyerApiDto[] | null;
    /** @format int64 */
    totalCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface SelectedShippingOption {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface OfferedShippingOption {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface PickListItemApiDto {
    /** @format uuid */
    purchaseOrderId: string;
    /** @format int32 */
    itemId: number;
    itemTitle?: string | null;
    itemUrl?: string | null;
    mainImage?: ItemImageUrls | null;
    mainImageTemplate?: string | null;
    /** @format int32 */
    price: number;
    isMarkedAsPaidBySeller: boolean;
    isMarkedAsShipped: boolean;
    /** @format date-time */
    transactionDate: string;
    hiddenBySeller: boolean;
    userReference?: string | null;
    /** @format double */
    totalDiscountAmount: number;
    hasSellerLeftFeedback: boolean;
    selectedShipping?: SelectedShippingOption | null;
    offeredShippingOptions?: OfferedShippingOption[] | null;
    /** @format int32 */
    transactionId: number;
}

export interface PickListBuyerV2ApiDto {
    /** @format int32 */
    buyerMemberId: number;
    buyerMemberAlias?: string | null;
    buyerContactDetails?: ContactDetailsApiDto | null;
    items?: PickListItemApiDto[] | null;
}

export interface MemberPickListV2ApiResponse {
    items?: PickListBuyerV2ApiDto[] | null;
    /** @format int64 */
    totalCount: number;
    /** @format int64 */
    filterHitCount: number;
    /** @format int32 */
    hiddenCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface FeatureSummaryDto {
    name?: string | null;
    /** @format int32 */
    price: number;
    /** @format int32 */
    count: number;
}

export interface CommissionFeeSummaryDto {
    /** @format double */
    minFee: number;
    /** @format double */
    maxFee: number;
    /** @format double */
    minPercentage: number;
    /** @format double */
    maxPercentage: number;
}

export interface RestartItemsSummaryApiResponse {
    features?: FeatureSummaryDto[] | null;
    commission?: CommissionFeeSummaryDto | null;
    isCompany: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface ShopItemPurchase {
    /** @format int32 */
    buyerMemberId: number;
    buyerMemberAlias?: string | null;
    /** @format int32 */
    buyerTotalRating: number;
    /** @format int32 */
    price: number;
    /** @format date-time */
    transactionDate: string;
    /** @format int32 */
    categoryId: number;
}

export interface ShopItemPurchaseHistoryApiResponse {
    /** @format int32 */
    itemId: number;
    shortDescription?: string | null;
    /** @format date-time */
    endDate: string;
    userReference?: string | null;
    purchases?: ShopItemPurchase[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    categoryId: number;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
}

export interface SelectedShipping {
    /** @format int32 */
    productId?: number | null;
    providerId?: string | null;
}

export interface ItemApiDto {
    /** @format int32 */
    id: number;
    shortDescription?: string | null;
    /** @format int32 */
    price: number;
    mainImageUrl?: ItemImageUrls | null;
    mainImageUrlTemplate?: string | null;
    selectedShipping?: SelectedShipping | null;
}

export interface MemberSoldItemShippingInfoV2ApiResponse {
    responseStatus?: ResponseStatus | null;
    item?: ItemApiDto | null;
    buyerContactDetails?: ContactDetailsApiDto | null;
    isQuickFlowPossible: boolean;
}

export interface MemberSoldItemByTransactionIdApiResponse {
    responseStatus?: ResponseStatus | null;
    item?: MemberSoldItemApiDto | null;
}

export interface MemberSoldItemBuyerInfoApiResponse {
    responseStatus?: ResponseStatus | null;
    items?: MemberSoldItemApiDto[] | null;
    buyerProfile?: PublicProfileApiDto | null;
    buyerContactDetails?: ContactDetailsApiDto | null;
    sellerContactDetails?: ContactDetailsApiDto | null;
    paymentOptions?: PaymentOptionApiDto[] | null;
    paidStatus?: string | null;
    paymentMethod?: string | null;
    /** @format double */
    totalOrderPrice: number;
    /** @format double */
    totalOrderPriceWithoutShipping: number;
}

export interface MemberSoldItemsApiResponse {
    /** @format int32 */
    notPaidCount: number;
    /** @format int32 */
    paidCount: number;
    /** @format int32 */
    shippedCount: number;
    /** @format int32 */
    hiddenCount: number;
    items?: MemberSoldItemApiDto[] | null;
    /** @format int64 */
    totalCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface MemberSoldItemsByPurchaseOrderIdApiResponse {
    responseStatus?: ResponseStatus | null;
    items?: MemberSoldItemApiDto[] | null;
}

export type MemberSoldItemsSummaryApiRequest = object;

export interface MemberSoldItemsSummaryApiDto {
    /** @format int32 */
    totalPrice: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    sumOpeningBids: number;
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    shopItemCount: number;
}

export interface MemberSoldItemsSummaryApiResponse {
    summary?: MemberSoldItemsSummaryApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export type MemberStatsThisMonthApiRequest = object;

export interface MemberStatsThisMonthApiResponse {
    /** @format int32 */
    soldThisMonthCount: number;
    /** @format int32 */
    activeThisMonthCount: number;
    /** @format int32 */
    unsoldThisMonthCount: number;
    /** @format int32 */
    listedThisMonthCount: number;
    /** @format int32 */
    maxFreeListingsPerMonth: number;
    responseStatus?: ResponseStatus | null;
}

export interface SetTransactionItemShippedApiRequest {
    /** @format int32 */
    transactionId: number;
    shipped: boolean;
}

export interface SetTransactionItemShippedApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type MemberSelloProfileApiRequest = object;

export interface MemberSelloProfileApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    memberId: number;
    /** @format date-time */
    memberSince: string;
    accountState: MemberAccountState;
    alias?: string | null;
    email?: string | null;
    firstName?: string | null;
    city?: string | null;
    isSwedishUser: boolean;
    isCompanyUser: boolean;
    hasShop: boolean;
    /** @format int32 */
    totalRating: number;
    /** @format float */
    detailedSellerRatingAverage?: number | null;
    /** @format int32 */
    combinedShippingDays: number;
}

export type MemberSessionDataApiRequest = object;

export interface MemberSessionDataApiResponse {
    /** @format int32 */
    memberId: number;
    email?: string | null;
    alias?: string | null;
    aliasSlug?: string | null;
    heroImageUrl?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    country?: string | null;
    countryCodeIso2?: string | null;
    languageCodeIso2?: string | null;
    birthDate?: string | null;
    /** @format float */
    detailedSellerRating?: number | null;
    appleId?: string | null;
    facebookId?: string | null;
    googleId?: string | null;
    klarnaId?: string | null;
    currencyCode?: string | null;
    automaticTranslationPreference: boolean;
    gender?: string | null;
    memberIdHash?: string | null;
    /** @format int32 */
    age?: number | null;
    responseStatus?: ResponseStatus | null;
    city?: string | null;
    blueshiftEventSignature?: string | null;
}

export interface SetShippingFeeRuleFreeShippingCostLimitApiRequest {
    useFreeShippingCostLimit: boolean;
    /** @format int32 */
    freeShippingCostLimit: number;
}

export interface SetShippingFeeRuleFreeShippingCostLimitApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetShippingFeeRuleShippingOptionApiRequest {
    shippingOption?: string | null;
}

export interface SetShippingFeeRuleShippingOptionApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface MemberShopDetailsApiResponse {
    /** @format int32 */
    memberId: number;
    alias?: string | null;
    logoFormat?: string | null;
    hasLogo: boolean;
    companyInfo?: string | null;
    contactInfo?: string | null;
    purchaseTerms?: string | null;
    responseStatus?: ResponseStatus | null;
}

export type MemberHasSsnApiRequest = object;

export interface MemberHasSsnApiResponse {
    responseStatus?: ResponseStatus | null;
    hasSsn: boolean;
}

export interface UpdateMemberSsnApiRequest {
    ssn?: string | null;
}

export interface UpdateMemberSsnApiResponse {
    responseStatus?: ResponseStatus | null;
    isValid: boolean;
}

export type GetMemberSuspendedUntilApiRequest = object;

export interface GetMemberSuspendedUntilApiResponse {
    /** @format date-time */
    suspendedUntil?: string | null;
    responseStatus?: ResponseStatus | null;
}

export type GetSystemMessagesApiRequest = object;

export enum SystemMessageType {
    InvoiceOverdue = 'InvoiceOverdue',
    InvoiceUnpaid = 'InvoiceUnpaid',
    PayoutFailed = 'PayoutFailed',
    PayoutReadyBankAccountMissing = 'PayoutReadyBankAccountMissing',
    BankAccountMissing = 'BankAccountMissing',
    HyperwalletPayeeVerificationRequired = 'HyperwalletPayeeVerificationRequired',
    HyperwalletPayeeVerificationUnderReview = 'HyperwalletPayeeVerificationUnderReview',
    PayoutProviderOnboardingFailed = 'PayoutProviderOnboardingFailed',
    KycQuestionnaire = 'KycQuestionnaire',
    PayoutReadyVerificationRequired = 'PayoutReadyVerificationRequired',
    OutstandingTraderaPayLicense = 'OutstandingTraderaPayLicense',
    PayoutReadyOutstandingTraderaPayLicense = 'PayoutReadyOutstandingTraderaPayLicense'
}

export enum SystemMessageSeverity {
    Warning = 'Warning',
    Info = 'Info'
}

export interface SystemMessage {
    type: SystemMessageType;
    severity: SystemMessageSeverity;
}

export interface GetSystemMessagesApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalCount: number;
    items?: SystemMessage[] | null;
}

export interface SetTransactionVisibilityApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    hidden: boolean;
}

export interface SetTransactionVisibilityApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UnpaidItemStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
    strikeSubmitted: boolean;
}

export interface UnpaidPurchaseOrderStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
    strikeSubmitted: boolean;
    items?: ItemStrikeSubmission[] | null;
}

export interface AddUnpaidPurchaseOrderStrikeApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
    comment?: string | null;
}

export interface AddUnpaidPurchaseOrderStrikeApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetMemberVatDetailsApiRequest = object;

export interface GetMemberVatDetailsApiResponse {
    memberIsSubjectToVat: boolean;
    responseStatus?: ResponseStatus | null;
    /** @format byte */
    selectableVatValues?: string | null;
}

export type GetMemberVerificationStatusApiRequest = object;

export interface GetMemberVerificationStatusApiResponse {
    responseStatus?: ResponseStatus | null;
    hasSsn: boolean;
    needsBankIdVerification: boolean;
    needsConsentOfTraderaPayAgreement?: string | null;
    isUnderLicense: boolean;
}

export type MemberWinnerEmailApiRequest = object;

export interface MemberWinnerEmailApiResponse {
    winnerEmail?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface SaveWinnerEmailApiRequest {
    winnerEmail?: string | null;
}

export interface SaveWinnerEmailApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface AddItemToWishListApiRequest {
    /** @format int32 */
    itemId: number;
}

export interface AddItemToWishListApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface RemoveItemsFromWishListApiRequest {
    itemIds?: number[] | null;
}

export interface RemoveItemFromWishListApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type GetWishListItemIdsApiRequest = object;

export interface GetWishListItemIdsApiResponse {
    responseStatus?: ResponseStatus | null;
    wishListItemsIds?: number[] | null;
}

export interface GetMemberWithAliasApiResponse {
    /** @format int32 */
    memberId: number;
    isCompanyUser: boolean;
    hasShopAccount: boolean;
    alias?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface AutoShipmentCheckoutEnabledUpdateParams {
    request?: SetAutoShipmentCheckoutMemberEnabledApiRequest;
}

export interface BlockedMembersCreateParams {
    request?: BlockMemberApiRequest;
}

export interface BlockedMembersRequest {
    request?: GetBlockedMembersApiRequest;
}

export interface BlockedMembersDeleteParams {
    request?: UnblockMemberApiRequest;
}

export interface BlueshiftCredentialsRequest {
    request?: GetBlueshiftEventApiCredentialsApiRequest;
}

export interface BuyerTransactionVisibilityCreateParams {
    request?: SetBuyerTransactionVisibilityApiRequest;
}

export interface CombinedShippingDaysUpdateParams {
    request?: SetCombinedShippingMemberDaysApiRequest;
}

export interface CombinedShippingEnabledUpdateParams {
    request?: SetCombinedShippingMemberEnabledApiRequest;
}

export interface CommitonpaymentEnabledUpdateParams {
    request?: SetCommitOnPaymentMemberEnabledApiRequest;
}

export interface ContactSellerCreateParams {
    request?: ContactSellerApiRequest;
}

export interface ContacthighestbidderCreateParams {
    request?: ContactHighestBidderApiRequest;
}

export interface DeactivateaccountCreateParams {
    request?: DeactivateMemberAccountPermanentlyApiRequest;
}

export interface DeactivateaccountRequest {
    request?: GetAccountDeactivationSettingsApiRequest;
}

export interface DeactivateaccounttemporarilyCreateParams {
    request?: DeactivateMemberAccountTemporarilyApiRequest;
}

export interface DetailsRequest {
    request?: MemberContactDetailsApiRequest;
}

export interface DetailsUpdateParams {
    request?: UpdateMemberContactDetailsApiRequest;
}

export interface DisputeRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface DisputeCreateParams {
    request?: CreateDisputeApiRequest;
}

export interface DisputeMessageCreateParams {
    request?: AddDisputeMessageApiRequest;
}

export interface ChangeStatusToAppealedCreateParams {
    request?: ChangeDisputeStatusToAppealedApiRequest;
}

export interface MarkAsEscalatedCreateParams {
    request?: MarkDisputeAsEscalatedApiRequest;
}

export interface MarkAsSolvedCreateParams {
    request?: MarkDisputeAsSolvedApiRequest;
}

export interface DisputesRequest {
    transactionIds?: number[];
}

export interface EmailSettingsRequest {
    request?: MemberEmailSettingsApiRequest;
}

export interface EmailSettingsUpdateParams {
    request?: UpdateMemberEmailSettingsApiRequest;
}

export interface FeedbackRequest {
    /** @format int32 */
    memberId?: number;
    feedbackRoleFilter?: FeedbackRoleFilter;
    feedbackRatingFilter?: FeedbackRatingFilter;
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface FeedbackRemovalDetailsRequest {
    /** @format int32 */
    feedbackRemovalRequestId?: number;
}

export interface ConfirmCreateParams {
    request?: ConfirmMutualFeedbackRemovalApiRequest;
}

export interface ConfirmationValidationRequest {
    /** @format int32 */
    id?: number;
}

export interface CreateCreateParams {
    request?: CreateFeedbackRemovalApiRequest;
}

export interface CreationValidationRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface DenyCreateParams {
    request?: DenyMutualFeedbackRemovalApiRequest;
}

export interface FeedbackRemovalsCreateParams {
    request?: FeedbackRemovalsApiRequest;
}

export interface ItemsRequest {
    /** @format int32 */
    memberId?: number;
    role?: FeedbackRoleFilter;
    rating?: FeedbackRatingFilter;
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface SummaryRequest {
    /** @format int32 */
    memberId?: number;
}

export interface TranslatedRequest {
    toLanguageCodeIso2?: string;
    feedbackIds?: number[];
}

export interface FeedbacksRequest {
    /** @format int32 */
    transactionId?: number;
    showDeleted?: boolean;
}

export interface GetcreditmemobyencryptedidRequest {
    encryptedId?: string;
}

export interface GetcreditmemopdfRequest {
    /** @format int64 */
    invoiceId?: number;
    creditMemoDocumentId?: string;
}

export interface GetcreditmemopdfbyidRequest {
    /** @format int64 */
    creditMemoId?: number;
}

export interface GetinvoicecsvRequest {
    /** @format int64 */
    invoiceId?: number;
}

export interface GetinvoicepdfRequest {
    /** @format int64 */
    invoiceId?: number;
}

export interface GetinvoicepdfbyencryptedidRequest {
    encryptedId?: string;
}

export interface GetinvoicesRequest {
    /** @format int32 */
    pageIndex?: number;
    /** @format int32 */
    itemsPerPage?: number;
}

export interface GetuninvoicedfeesRequest {
    /** @format int32 */
    pageIndex?: number;
    /** @format int32 */
    itemsPerPage?: number;
    getThumbUrl?: boolean;
}

export interface FindRequest {
    query?: string;
    /** @format int32 */
    page?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface GetavailablecountriesforshippingRequest {
    request?: GetAvailableCountriesForShippingApiRequest;
}

export interface GradeTransactionsRequest {
    gradeIds?: number[];
}

export interface ImageUploadUrlRequest {
    contentType?: string;
}

export interface ItemVisibilityCreateParams {
    request?: SetItemVisibilityApiRequest;
}

export interface CompleteQuestionnaireCreateParams {
    request?: CompleteQuestionnaireApiRequest;
}

export interface InitializeQuestionnaireCreateParams {
    request?: InitializeQuestionnaireApiRequest;
}

export interface PendingActionsRequest {
    request?: GetKycPendingActionsApiRequest;
}

export interface QuestionnaireCreateParams {
    request?: AnswerQuestionnaireApiRequest;
}

export interface QuestionnaireRequest {
    actionType?: string;
    languageCodeIso2?: string;
}

export interface LastnotifiedCreateParams {
    request?: SetLastNotifiedApiRequest;
}

export interface PagedTransactionsRequest {
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface TransactionsRequest {
    transactionIds?: number[];
}

export interface SetAutoShipmentCheckoutMemberEnabledApiRequest4 {
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface SetAutoShipmentCheckoutMemberEnabledApiRequest6 {
    transactionIds?: number[];
}

export interface BuyerRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface BuyerCreateParams {
    request?: SaveFeedbackAsBuyerApiRequest;
}

export interface CommentCreateParams {
    request?: CommentFeedbackApiRequest;
}

export interface SellerRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface SellerCreateParams {
    request?: SaveFeedbackAsSellerApiRequest;
}

export interface ListSettingsRequest {
    request?: MemberListSettingsApiRequest;
}

export interface McpStrikeRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface McpStrikeCreateParams {
    request?: AddMutualCancelOfPurchaseStrikeApiRequest;
}

export interface McpStrikeConfirmCreateParams {
    request?: ConfirmMutualCancelOfPurchaseStrikeApiRequest;
}

export interface MemberemailnotificationssettingsviewmodelRequest {
    request?: GetMemberEmailNotificationsSettingsViewModelApiRequest;
}

export interface MemberprofilesettingsviewmodelRequest {
    request?: GetMemberProfileSettingsViewModelApiRequest;
}

export interface MembersecuritysettingsviewmodelRequest {
    request?: GetMemberSecuritySettingsViewModelApiRequest;
}

export interface MembersellersettingsviewmodelRequest {
    request?: GetMemberSellerSettingsViewModelApiRequest;
}

export interface EmailnotifyRequest {
    /** @format int32 */
    memberId?: number;
}

export interface EmailnotifyUpdateParams {
    request?: SetMessagingEmailNotifyApiRequest;
}

export interface MyParticipationRequest {
    request?: GetMessagingMyParticipationApiRequest;
}

export interface ParticipationRequest {
    /** @format int32 */
    memberId?: number;
}

export interface ParticipationUpdateParams {
    request?: SetMessagingParticipationApiRequest;
}

export interface StatsRequest {
    request?: GetMessagingStatsApiRequest;
}

export interface NotificationsRequest {
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
}

export interface BankaccountDeleteParams {
    request?: RemoveBankAccountPayoutTransferMethodApiRequest;
}

export interface BankaccountCreateParams {
    request?: SetBankAccountPayoutTransferMethodApiRequest;
}

export interface CompletehyperwallettransfermethodCreateParams {
    request?: CompleteHyperwalletTransferMethodApiRequest;
}

export interface HyperwalletauthenticationtokenRequest {
    request?: GetHyperwalletAuthenticationTokenApiRequest;
}

export interface HyperwallettransfermethodviewmodelRequest {
    request?: GetHyperwalletTransferMethodViewModelApiRequest;
}

export interface MatchbankCreateParams {
    request?: MatchBankApiRequest;
}

export interface MemberpayoutsettingsviewmodelRequest {
    request?: GetMemberPayoutSettingsViewModelApiRequest;
}

export interface PaypalDeleteParams {
    request?: RemovePayPalPayoutTransferMethodApiRequest;
}

export interface PaypalCreateParams {
    request?: SetPayPalPayoutTransferMethodApiRequest;
}

export interface SethyperwalletpayeeverificationassubmittedCreateParams {
    request?: SetHyperwalletPayeeVerificationAsSubmittedApiRequest;
}

export interface TinkaccountCreateParams {
    request?: SetPayoutTransferMethodUsingTinkApiRequest;
}

export interface PonrStrikeRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface PonrStrikeCreateParams {
    request?: AddPurchaseOrderNotReceivedStrikeApiRequest;
}

export interface BankIdPasswordRecoveryCancelCreateParams {
    request?: BankIdPasswordRecoveryCancelApiRequest;
}

export interface BankIdProgressWithIdRequest {
    bankIdOrderRef?: string;
    /** @format int32 */
    memberid?: number;
}

export interface BankIdRecoveryWithIdCreateParams {
    request?: BankIdBeginWithIdApiRequest;
}

export interface BankidVerificationRequest {
    /** @format int32 */
    fixedPrice?: number;
}

export interface BraintreeOnboardingDetailsRequest {
    request?: GetBraintreeOnboardingDetailsApiRequest;
}

export interface ChangealiasCreateParams {
    request?: ChangeAliasApiRequest;
}

export interface ChangeemailCreateParams {
    request?: ChangeEmailWithIdApiRequest;
    memberId: string;
}

export interface ChangepasswordCreateParams {
    request?: ChangePasswordApiRequest;
}

export interface ChangepasswordCreate2Params {
    request?: ChangePasswordWithIdApiRequest;
    memberId: string;
}

export interface ConsentCreateParams {
    request?: SetMemberConsentApiRequest;
}

export interface CreateVerificationCodeCreateParams {
    request?: CreateVerificationCodeApiRequest;
}

export interface CreateVerificationCodeWithMemberIdCreateParams {
    request?: CreateVerificationCodeWithMemberIdApiRequest;
}

export interface CurrencyUpdateParams {
    request?: UpdateMemberCurrencyApiRequest;
}

export interface GethyperwalletmemberdetailsRequest {
    request?: GetHyperwalletMemberDetailsApiRequest;
}

export interface GetiscombinedshippingenabledRequest {
    request?: GetIsCombinedShippingEnabledApiRequest;
}

export interface GetistraderapayenabledRequest {
    request?: GetIsTraderaPayEnabledApiRequest;
}

export interface GetshippinginvoicememberRequest {
    request?: GetShippingInvoiceMemberApiRequest;
}

export interface GettraderapaymemberdetailsRequest {
    request?: GetTraderaPayMemberApiRequest;
}

export interface GettraderapayonboardingdetailsRequest {
    request?: GetTraderaPayOnboardingDetailsApiRequest;
}

export interface HaswalletRequest {
    request?: GetHasWalletApiRequest;
}

export interface LanguageUpdateParams {
    request?: UpdateMemberLanguageApiRequest;
}

export interface MemberIdentificationBankIdPasswordRecoveryCancelCreateParams {
    request?: MemberIdentificationBankIdPasswordRecoveryCancelApiRequest;
}

export interface MemberIdentificationBankIdProgressWithIdRequest {
    bankIdOrderRef?: string;
    /** @format int32 */
    memberid?: number;
}

export interface MemberIdentificationBankIdRecoveryWithIdCreateParams {
    request?: MemberIdentificationBeginBankIdWithIdApiRequest;
}

export interface MemberIdentificationChangeemailCreateParams {
    request?: MemberIdentificationChangeEmailWithIdApiRequest;
    memberId: string;
}

export interface MemberLocalizationRequest {
    request?: GetMemberLocalizationApiRequest;
}

export interface MemberconsentRequest {
    request?: GetMemberConsentApiRequest;
}

export interface PayoutfrequencyRequest {
    request?: GetPayoutFrequencyApiRequest;
}

export interface PayoutfrequencyoptionsRequest {
    request?: GetPayoutFrequencyOptionsApiRequest;
}

export interface RemovetraderapaypayoutdestinationCreateParams {
    request?: RemoveTraderaPayPayoutDestinationApiRequest;
}

export interface SelectedDescriptionLanguageUpdateParams {
    request?: UpdateMemberSelectedDescriptionLanguageApiRequest;
}

export interface SetpayoutfrequencyCreateParams {
    request?: SetPayoutFrequencyApiRequest;
}

export interface ShippingFromCountryUpdateParams {
    request?: UpdateMemberShippingFromCountryApiRequest;
}

export interface SmsCheckCreateParams {
    request?: SmsCheckApiRequest;
}

export interface SmsVerificationCreateParams {
    request?: SendVerificationSmsApiRequest;
}

export interface SmsVerificationRequest {
    action?: string;
}

export interface SmsVerificationWithIdCreateParams {
    request?: SendVerificationSmsWithIdApiRequest;
}

export interface Swishapp2AppDisableCreateParams {
    request?: SwishApp2AppMemberDisableApiRequest;
}

export interface Swishapp2AppOptoutCreateParams {
    request?: SwishApp2AppMemberOptOutApiRequest;
}

export interface Swishapp2AppSavephonenumberCreateParams {
    request?: SwishApp2AppMemberSavePhoneNumberApiRequest;
}

export interface Swishapp2AppSetverifiedCreateParams {
    request?: SwishApp2AppMemberSetVerifiedApiRequest;
}

export interface Swishapp2AppVerifycodeCreateParams {
    request?: SwishApp2AppMemberVerifyCodeApiRequest;
}

export interface TinkBankaccountsRequest {
    code?: string;
}

export interface TinkLinkRequest {
    request?: TinkGetLinkApiRequest;
}

export interface TranslationPreferenceUpdateParams {
    request?: UpdateMemberTranslationPreferenceApiRequest;
}

export interface ValidateExistingPasswordCreateParams {
    request?: ValidateExistingPasswordForMemberApiRequest;
}

export interface VerifyNonmobilePincodeCreateParams {
    request?: VerifyNonMobilePincodeApiRequest;
}

export interface VerifyNonmobilePincodeWithIdCreateParams {
    request?: VerifyNonMobilePincodeWithIdApiRequest;
}

export interface VerifyPincodeCreateParams {
    request?: VerifyPincodeApiRequest;
}

export interface VerifyPincodeWithIdCreateParams {
    request?: VerifyPincodeWithIdApiRequest;
}

export interface PublicProfileHeroImageDeleteParams {
    request?: RemoveMemberPublicProfileHeroImageApiRequest;
}

export interface PublicProfileHeroImageUpdateParams {
    request?: UpdateMemberPublicProfileHeroImageApiRequest;
}

export interface PublicProfileInformationUpdateParams {
    request?: UpdateMemberPublicProfileInformationApiRequest;
}

export interface PublicWishlistDetailParams {
    statusFilter?: WishListStatusFilter;
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
    languageCodeIso2?: string;
    /** @format int32 */
    memberId: number;
}

export interface PublicprofileRequest {
    /** @format int32 */
    memberId?: number;
    toLanguageCodeIso2?: string;
}

export interface PurchaseRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface PurchaseorderRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface PurchaseorderitemRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface SellerAutoFeedbackUpdateParams {
    request?: SaveSellerAutoFeedbackSettingsApiRequest;
}

export interface SellerAutoFeedbackRequest {
    request?: SellerAutoFeedbackApiRequest;
}

export interface SellerAutoPaymentReminderUpdateParams {
    request?: SaveSellerAutoPaymentReminderSettingsApiRequest;
}

export interface SellerAutoPaymentReminderRequest {
    request?: SellerAutoPaymentReminderApiRequest;
}

export interface ActivesummaryRequest {
    request?: MemberActiveItemsSummaryApiRequest;
}

export interface FeatureSummaryByIdsRequest {
    itemIds?: number[];
}

export interface ItemShippedCreateParams {
    request?: SetItemShippedApiRequest;
}

export interface ItemShippingBookedCreateParams {
    request?: SetItemShippingBookedApiRequest;
}

export interface MarkedAsPaidBySellerCreateParams {
    request?: MarkAsPaidBySellerApiRequest;
}

export interface PicklistRequest {
    /** @format int32 */
    pageIndex?: number;
    /** @format int32 */
    itemsPerPage?: number;
    retrieveHidden?: boolean;
    paidStatus?: PickListFilterPaidStatus;
    shippedStatus?: PickListFilterShippedStatus;
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
}

export interface PicklistV2Request {
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
    retrieveHidden?: boolean;
    paidStatus?: PickListFilterPaidStatus;
    shippedStatus?: PickListFilterShippedStatus;
    /** @format date-time */
    fromDate?: string;
    /** @format date-time */
    toDate?: string;
}

export interface RestartItemsSummaryRequest {
    itemIds?: number[];
}

export interface ShopitemOrderhistoryRequest {
    /** @format int32 */
    itemId?: number;
}

export interface SolditemsRequest {
    soldItemStateFilter?: string;
    soldItemOrderBy?: string;
    retrieveHidden?: boolean;
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
}

export interface SoldsummaryRequest {
    request?: MemberSoldItemsSummaryApiRequest;
}

export interface StatsThisMonthRequest {
    request?: MemberStatsThisMonthApiRequest;
}

export interface TransactionItemShippedCreateParams {
    request?: SetTransactionItemShippedApiRequest;
}

export interface SelloprofileRequest {
    request?: MemberSelloProfileApiRequest;
}

export interface SessionDataRequest {
    request?: MemberSessionDataApiRequest;
}

export interface ShippingFeeRuleFreeShippingCostLimitUpdateParams {
    request?: SetShippingFeeRuleFreeShippingCostLimitApiRequest;
}

export interface ShippingFeeRuleShippingOptionUpdateParams {
    request?: SetShippingFeeRuleShippingOptionApiRequest;
}

export interface ShopDetailsRequest {
    /** @format int32 */
    memberId?: number;
}

export interface GetSsnParams {
    request?: MemberHasSsnApiRequest;
}

export interface PutSsnParams {
    request?: UpdateMemberSsnApiRequest;
}

export interface SuspendedUntilRequest {
    request?: GetMemberSuspendedUntilApiRequest;
}

export interface SystemMessagesRequest {
    request?: GetSystemMessagesApiRequest;
}

export interface TransactionFeedbackRemovalRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface TransactionVisibilityCreateParams {
    request?: SetTransactionVisibilityApiRequest;
}

export interface UpiStrikeRequest {
    /** @format int32 */
    transactionId?: number;
}

export interface UppoStrikeRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface UppoStrikeCreateParams {
    request?: AddUnpaidPurchaseOrderStrikeApiRequest;
}

export interface VatdetailsRequest {
    request?: GetMemberVatDetailsApiRequest;
}

export interface VerificationStatusRequest {
    request?: GetMemberVerificationStatusApiRequest;
}

export interface WinnerEmailRequest {
    request?: MemberWinnerEmailApiRequest;
}

export interface WinnerEmailUpdateParams {
    request?: SaveWinnerEmailApiRequest;
}

export interface WishlistCreateParams {
    request?: AddItemToWishListApiRequest;
}

export interface WishlistRequest {
    statusFilter?: WishListStatusFilter;
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
    languageCodeIso2?: string;
}

export interface WishlistDeleteParams {
    request?: RemoveItemsFromWishListApiRequest;
}

export interface ItemIdsRequest {
    request?: GetWishListItemIdsApiRequest;
}

export interface WithAliasRequest {
    alias?: string;
}
